
import axios from '../wmsAxios'

/*
 * 机构管理模块
 */

// 保存

// 批量保存
export const saveBatch = (data) => {
    return axios({
        url: '/tblTempExcelImportItemMaster/saveBatch',
        method: 'post',
        data
    })
}
export const save = (data) => {
    return axios({
        url: '/tblTempExcelImportItemMaster/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tblTempExcelImportItemMaster/delete',
        method: 'post',
        data
    })
}
// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tblTempExcelImportItemMaster/findPage',
        method: 'post',
      data
    })
}
// 导入Excel
export const importExcel = (data) => {
  return axios({
    url: '/tblTempExcelImportItemMaster/importExcel',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tblTempExcelImportItemMaster.js